import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

class MobileSelectedFacets extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        require('./MobileSelectedFacets.css');
    }

    render() {
        const { attributes, onAttributeChange, onClearAttributes } = this.props;

        const selectedAttributeValueArrays = attributes.map(function (attribute) {
            return attribute.Values.filter(
                value => value.Checked).map(value => {
                    return {
                        attributeName: attribute.Name,
                        attributeValueName: value.Name
                    };
                });
        });

        const mergedAttributeValueArrays = [].concat.apply([], selectedAttributeValueArrays);
        const showMobileSelectedFacets = mergedAttributeValueArrays.length > 0;
        const activeFilters = attributes.map(attr => ({
            ...attr,
            values: attr.Values.filter(value => value.Checked)
        }));
        const showClearAttributes = attributes.filter(
            attribute => attribute.Values.filter(
                value => value.Checked).length > 0).length > 0;
        return (
            <div>
                {showMobileSelectedFacets &&
                    <div className="mobile-selected-facets mb-3">
                        
                    {
                        activeFilters.map(attr => (
                            attr.values.map(filter => (
                                <span className="filter clear-all-filters"
                                    key={filter.Name}
                                    onClick={(e) => { onAttributeChange(attr.Name, filter.Name) }}>
                                    {filter.Name}
                                    <i className="fas fa-times ml-1"></i>
                                </span>
                            ))
                        ))
                    }
                    {showClearAttributes &&
                        <a
                            onClick={onClearAttributes}
                            className="clear-all-filters"
                            href="#"
                        >
                            {translateResourceString("/SearchApp/ClearAll")}
                            </a>
                    }
                    </div>
                }
            </div>
        );
    }
}

MobileSelectedFacets.propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })).isRequired,
    onAttributeChange: PropTypes.func.isRequired,
    onClearAttributes: PropTypes.func.isRequired
};

export default MobileSelectedFacets;